import React, {useEffect, useState} from 'react';
import {useFormik} from 'formik';
import * as Yup from 'yup';

import {Card, Divider, Input} from "antd";

import {Label} from "@/components/ui/label";
import {useApiCreateAdminSetting, useApiSearchAdminSettings} from "@/api/settings";
import {toast} from 'react-hot-toast';
import {Button} from "antd";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";
import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";

function AdminAcademySettingPage(props) {
    const [isLoading, setIsLoading] = useState(false);

    // Fetch settings
    const {data: settingsData, isLoading: isLoadingSettings, refetch} = useApiSearchAdminSettings({});

    // Update settings mutation
    const updateSettingsMutation = useApiCreateAdminSetting();

    // Form validation schema
    const validationSchema = Yup.object({
        mellat_payer_id: Yup.number().nullable('شناسه پرداخت کننده الزامی است'),
        enamad_code: Yup.string().nullable('کد اینماد الزامی است'),
        enamad_number: Yup.number().nullable('کد اینماد الزامی است'),
        // maxchargeaccount: Yup.string().nullable('حداکثر شارژ حساب الزامی است'),
        // absence_allow_days: Yup.number()
        //     .min(0, 'تعداد روزهای غیبت باید حداقل 0 باشد')
        //     .max(30, 'تعداد روزهای غیبت نمی‌تواند بیشتر از 30 باشد')
        //     .nullable('تعداد روزهای غیبت الزامی است'),
        // maxminusaccount: Yup.string(),
        // accpetequivalent: Yup.object({
        //     status: Yup.boolean(),
        //     sms: Yup.string().oneOf(['on', 'off']),
        //     text: Yup.string().nullable('متن پیام تایید الزامی است')
        // }),
        // rejectequivalent: Yup.object({
        //     status: Yup.boolean(),
        //     sms: Yup.string().oneOf(['on', 'off']),
        //     text: Yup.string().nullable('متن پیام رد الزامی است')
        // }),
        // takenewlesson: Yup.object({
        //     status: Yup.boolean(),
        //     sms: Yup.string().oneOf(['on', 'off']),
        //     text: Yup.string()
        // }),
        // limitations: Yup.object({
        //     iranmobilenumber: Yup.boolean().nullable(),
        //     iranianperson: Yup.boolean().nullable(),
        //     lockupdateprofile: Yup.string().oneOf(['on', 'off'])
        // })
    });

    const formik = useFormik({
        initialValues: {
            mellat_payer_id: '',
            enamad_code: '',
            enamad_number: '',
            // maxchargeaccount: '',
            // absence_allow_days: '',
            // maxminusaccount: '',
            // accpetequivalent: {
            //     status: false,
            //     sms: 'on',
            //     text: ''
            // },
            // rejectequivalent: {
            //     status: false,
            //     sms: 'on',
            //     text: ''
            // },
            // takenewlesson: {
            //     status: true,
            //     sms: 'on',
            //     text: ''
            // },
            // limitations: {
            //     iranmobilenumber: null,
            //     iranianperson: null,
            //     lockupdateprofile: 'on'
            // }
        },
        validationSchema,
        onSubmit: async (values) => {
            setIsLoading(true);
            try {
                await updateSettingsMutation.mutateAsync(values);
                toast.success('تنظیمات با موفقیت ذخیره شد');
                refetch();
            } catch (error) {
                toast.error('خطا در ذخیره تنظیمات');
                console.error('Error updating settings:', error);
            } finally {
                setIsLoading(false);

            }
        }
    });

    // Update form values when settings data is loaded
    useEffect(() => {
        if (settingsData?.data?.data) {
            const data = settingsData.data?.data;
            formik.setValues({
                mellat_payer_id: data.mellat_payer_id || '',
                enamad_code: data.enamad_code || '',
                enamad_number: data.enamad_number || '',
                // maxchargeaccount: data.maxchargeaccount || '',
                // absence_allow_days: data.absence_allow_days || '',
                // maxminusaccount: data.maxminusaccount || '',
                // accpetequivalent: data.accpetequivalent || {
                //     status: false,
                //     sms: 'on',
                //     text: ''
                // },
                // rejectequivalent: data.rejectequivalent || {
                //     status: false,
                //     sms: 'on',
                //     text: ''
                // },
                // takenewlesson: data.takenewlesson || {
                //     status: true,
                //     sms: 'on',
                //     text: ''
                // },
                // limitations: data.limitations || {
                //     iranmobilenumber: null,
                //     iranianperson: null,
                //     lockupdateprofile: 'on'
                // }
            });
        }
    }, [settingsData]);


    return (
        <>
            <AdminLayout pageTitle={'تننظیمات مرکز آموزشی'} backTo={URLS.admin.setting.dashboard}>

                <form onSubmit={formik.handleSubmit}>
                    <div className=" space-y-6">
                        <Card className={''}>
                            <div>
                                <div className="text-xl font-bold text-right">تنظیمات مرکز آموزشی</div>
                                <Divider />
                            </div>


                            <div className="space-y-6">
                                {/* Basic Settings */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div className="space-y-2">
                                        <Label htmlFor="mellat_payer_id" className="text-right block">
                                            شناسه پرداخت درگاه بانک ملت
                                        </Label>
                                        <Input
                                            id="mellat_payer_id"
                                            name="mellat_payer_id"
                                            type="number"
                                            value={formik.values.mellat_payer_id}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={formik.touched.mellat_payer_id && formik.errors.mellat_payer_id ? 'border-red-500' : ''}
                                            placeholder="مثال: 122144"
                                        />
                                        {formik.touched.mellat_payer_id && formik.errors.mellat_payer_id && (
                                            <p className="text-red-500 text-sm text-right">{formik.errors.mellat_payer_id}</p>
                                        )}
                                    </div>
                                </div>


                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div className="space-y-2">
                                        <Label htmlFor="enamad_code" className="text-right block">
                                            کد اینماد
                                        </Label>
                                        <Input
                                            id="enamad_code"
                                            name="enamad_code"
                                            type="text"
                                            value={formik.values.enamad_code}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={formik.touched.enamad_code && formik.errors.enamad_code ? 'border-red-500' : ''}
                                            placeholder="کداینماد"
                                        />
                                        {formik.touched.enamad_code && formik.errors.enamad_code && (
                                            <p className="text-red-500 text-sm text-right">{formik.errors.enamad_code}</p>
                                        )}
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div className="space-y-2">
                                        <Label htmlFor="enamad_number" className="text-right block">
                                            شناسه عددی اینماد
                                        </Label>
                                        <Input
                                            id="enamad_number"
                                            name="enamad_number"
                                            type="number"
                                            value={formik.values.enamad_number}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={formik.touched.enamad_number && formik.errors.enamad_number ? 'border-red-500' : ''}
                                            placeholder="شناسه عددی اینماد"
                                        />
                                        {formik.touched.enamad_number && formik.errors.enamad_number && (
                                            <p className="text-red-500 text-sm text-right">{formik.errors.enamad_number}</p>
                                        )}
                                    </div>
                                </div>

                            </div>

                            <div className="flex justify-end gap-3">
                                <Can permission={PermList.SETTINGS_EDIT}>
                                    <Button
                                        onClick={() => formik.submitForm()}
                                        type="primary"
                                        disabled={isLoading || !formik.isValid}
                                        className="min-w-[120px]"
                                    >
                                        ذخیره تنظیمات
                                    </Button>
                                </Can>

                            </div>

                        </Card>
                    </div>
                </form>
            </AdminLayout>
        </>
    );
}

export default AdminAcademySettingPage;